import "./styles/CollectionItem.scss";
import { Avatar } from "@mui/material";

interface ICollectionItem {
  addToCollections: (folderId: string) => void;
  collection: any;
}

export const CollectionItem = (props: ICollectionItem) => {
  const {
    collection: {
      folderId,
      folderName,
      thumbs
    },
    addToCollections
  } = props;

  return (
    <div className="CollectionItem" onClick={() => addToCollections(folderId)}>
      <div className="CollectionItem-Img">
        <Avatar src={thumbs} alt={folderName} />
      </div>
      <span className="CollectionItem-Title">{folderName}</span>
    </div>
  );
};
